export const ToolbarStackComponent = {
  bindings: {
    topText: '<',
    bottomText: '<'
  },
  template: `
      <strong> {{ $ctrl.topText }} </strong>
      <div>{{$ctrl.bottomText}}</div>
    `
};

// there really is no benefit in this at the moment - I may simply remove it if I end up not needing it for OM-5
export const AptToolbarComponent = {
  //
};
